import request from './request'

export const validateCart = (cart) => {
    return new Promise((resolve, reject) => {
        request.post(`cart`, cart)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const saveOrder = (payload) => {
    return new Promise((resolve, reject) => {
        request.post(`order`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const capturePayment = (payload) => {
    return new Promise((resolve, reject) => {
        request.post(`order/payment`, payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const checkOrderStatus = (order_id) => {
    return new Promise((resolve, reject) => {
        request.get(`order/${order_id}`)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}